// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  display: flex;
  gap: 8px;
  align-items: center;
}
.pagination .page-button {
  padding: 8px 12px;
  border: 1px solid var(--dark-color-lightest);
  background-color: var(--white-color-lightest);
  cursor: pointer;
}
.pagination .page-button.active {
  background-color: var(--primary-color-dark);
  color: var(--white-color-lightest);
  font-weight: bold;
}
.pagination .page-button:hover {
  background-color: var(--primary-color-light);
  color: var(--white-color-lightest);
  font-weight: bold;
}
.pagination .ellipsis {
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Pagination.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AACJ;AAAI;EACI,iBAAA;EACA,4CAAA;EACA,6CAAA;EACA,eAAA;AAER;AACI;EACI,2CAAA;EACA,kCAAA;EACA,iBAAA;AACR;AACI;EACI,4CAAA;EACA,kCAAA;EACA,iBAAA;AACR;AACI;EACI,YAAA;AACR","sourcesContent":[".pagination {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: center;\r\n    .page-button {\r\n        padding: 8px 12px;\r\n        border: 1px solid var(--dark-color-lightest);\r\n        background-color: var(--white-color-lightest);\r\n        cursor: pointer;\r\n    }\r\n\r\n    .page-button.active {\r\n        background-color: var(--primary-color-dark);\r\n        color: var(--white-color-lightest);\r\n        font-weight: bold;\r\n    }\r\n    .page-button:hover  {\r\n        background-color: var(--primary-color-light);\r\n        color: var(--white-color-lightest);\r\n        font-weight: bold;\r\n    }\r\n    .ellipsis {\r\n        padding: 8px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
